/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { N800 } from '@atlaskit/theme/colors';
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';
var descriptionStyles = css({
  marginTop: 0,
  marginBottom: "".concat(getGridSize() * 3, "px"),
  color: token('color.text.highEmphasis', N800)
});
/**
 * __Description__
 *
 * Description of Empty State.
 *
 * @internal
 */

var Description = function Description(_ref) {
  var children = _ref.children;
  return jsx("p", {
    css: descriptionStyles
  }, children);
};

export default Description;